import { z } from 'zod';

const numberOrEmpty = z
  .union([z.literal(''), z.coerce.number().nonnegative()])
  .transform((val) => (val === '' ? undefined : val))
  .optional();

export const pgIntervalSchema = z
  .object({
    seconds: numberOrEmpty.optional(),
    minutes: numberOrEmpty.optional(),
    hours: numberOrEmpty.optional(),
    days: numberOrEmpty.optional(),
    weeks: numberOrEmpty.optional(),
    months: numberOrEmpty.optional(),
    years: numberOrEmpty.optional(),
  })
  .refine((interval) => Object.values(interval).some((v) => typeof v === 'number' && !isNaN(v)), {
    message: 'At least one unit must be specified.',
  });

export default pgIntervalSchema;
